import { render, staticRenderFns } from "./materialDialog.vue?vue&type=template&id=d2743fe8&scoped=true"
import script from "./materialDialog.vue?vue&type=script&lang=js"
export * from "./materialDialog.vue?vue&type=script&lang=js"
import style0 from "./materialDialog.vue?vue&type=style&index=0&id=d2743fe8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2743fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2743fe8')) {
      api.createRecord('d2743fe8', component.options)
    } else {
      api.reload('d2743fe8', component.options)
    }
    module.hot.accept("./materialDialog.vue?vue&type=template&id=d2743fe8&scoped=true", function () {
      api.rerender('d2743fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/components/materialDialog.vue"
export default component.exports